/**
 * This file is auto-generated from ErrorPage.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const pageNotFoundTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Page Not Found';
        case 'pl':
            return 'Strona nie znaleziona';
    }
};

export const pageNotFoundDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return "The page you are looking for doesn't exist or has been moved.";
        case 'pl':
            return 'Strona, której szukasz, nie istnieje lub została przeniesiona.';
    }
};

export const internalServerErrorTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Something went wrong';
        case 'pl':
            return 'Coś poszło nie tak';
    }
};

export const internalServerErrorDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'We encountered an unexpected error. Please try again later.';
        case 'pl':
            return 'Napotkaliśmy nieoczekiwany błąd. Spróbuj ponownie później.';
    }
};

export const serviceUnavailableTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Service Unavailable';
        case 'pl':
            return 'Usługa niedostępna';
    }
};

export const serviceUnavailableDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'The service is temporarily unavailable. Please try again in a few moments.';
        case 'pl':
            return 'Usługa jest tymczasowo niedostępna. Spróbuj ponownie za kilka chwil.';
    }
};

export const unexpectedErrorTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Unexpected Error';
        case 'pl':
            return 'Nieoczekiwany błąd';
    }
};

export const unexpectedErrorDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'An unexpected error occurred. Please contact support if the problem persists.';
        case 'pl':
            return 'Wystąpił nieoczekiwany błąd. Skontaktuj się z pomocą techniczną, jeśli problem będzie się powtarzał.';
    }
};

export const refresh: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Refresh page';
        case 'pl':
            return 'Odśwież stronę';
    }
};
